const DATE_INPUT_LENGTH = 10
const DATE_TIME_INPUT_LENGTH = 16

const isValidDate = date => date instanceof Date && !Number.isNaN(date.getTime())

const padDatePart = value => String(value).padStart(2, '0')

export const toDateInputValue = date => {
  if (!date) return ''

  if (typeof date === 'string') return date.slice(0, DATE_INPUT_LENGTH)

  if (!isValidDate(date)) return ''

  return [date.getFullYear(), padDatePart(date.getMonth() + 1), padDatePart(date.getDate())].join(
    '-'
  )
}

export const toDateTimeLocalInputValue = date => {
  if (!date) return ''

  if (typeof date === 'string') return date.slice(0, DATE_TIME_INPUT_LENGTH)

  if (!isValidDate(date)) return ''

  const dateValue = toDateInputValue(date)
  const timeValue = [padDatePart(date.getHours()), padDatePart(date.getMinutes())].join(':')

  return `${dateValue}T${timeValue}`
}

export const fromDateInputValue = value => {
  if (!value) return null

  const [year, month, day] = value.split('-').map(Number)

  if (!year || !month || !day) return null

  const date = new Date(year, month - 1, day)

  return isValidDate(date) ? date : null
}

export const fromDateTimeLocalInputValue = value => {
  if (!value) return null

  const [datePart, timePart = '00:00'] = value.split('T')
  const [year, month, day] = datePart.split('-').map(Number)
  const [hours, minutes] = timePart.split(':').map(Number)

  if (!year || !month || !day || Number.isNaN(hours) || Number.isNaN(minutes)) return null

  const date = new Date(year, month - 1, day, hours, minutes)

  return isValidDate(date) ? date : null
}

export const getTodayDateInputValue = () => toDateInputValue(new Date())

export const getNowDateTimeLocalInputValue = () => toDateTimeLocalInputValue(new Date())
